import React, { Component } from "react";
import { connect } from "react-redux";
import { utils } from "@mc/mc-legacy";
import GroupMenu from "../components/GroupMenu";
import CustomPageLayout from "./CustomPageLayout";
import ItemList from "../components/ItemList";
import * as actions from "../actions/pozadavkyActions";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import { Button, Col, Row } from "reactstrap";
import SignRequestTitle from "../components/SignRequestTitle";
import ShowButton from "../components/ShowButton";
import VysledkyVyhledaniFilter from "../components/VysledkyVyhledaniFilter";
import RequestDocumentStatusIcon from "../components/RequestDocumentStatusIcon";
import { parse } from "query-string";
import MessageEmptyList from "../components/MessageEmptyList";
import LabeledValue from "../components/LabeledValue";
import * as appUtils from "../utils/appUtils";
import moment from "moment";
import EnumState from "../api/gen/qsign/types/EnumState";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
/**
 * Výsledek vyhledávání page
 */

class VysledkyVyhledaniPage extends React.Component {
  componentDidMount() {
    this.fetchData(this.props, false);
    this.handleFilter();
  }

  handleFilter() {
    const { itemList } = this.props;
    const searchParams = parse(this.props.history.location.search);
    this.props.dispatch(actions.filter({ ...itemList.filter, fulltext: searchParams.q }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps, false);
  }

  fetchData = (props, forceFetch) => {
    const { dispatch } = props;
    dispatch(actions.fetchIfNeeded(forceFetch));
  };
  handleZobrazit = (signRequest, onClose, viewMode) => {
    this.props.dispatch(pdfViewerActions.showDocument(signRequest, onClose, viewMode));
  };
  renderSignedOrRejected = (item) => {
    if (item.state === EnumState.REJECTED) {
      return <LabeledValue label="Odmítnuto" value={item.rejected ? this.formatDate(item.rejected) : "-"} />;
    } else if (item.state === EnumState.SIGNED) {
      return <LabeledValue label="Podepsáno" value={item.signed ? this.formatDate(item.signed) : "-"} />;
    }

    return null;
  };
  formatDate = (date) => {
    return moment(date).format("DD.M.YYYY");
  };
  renderItem = (item: SignRequestDocumentVO) => {
    const { error } = item;
    return (
      <Row noGutters className={"document-row"}>
        <Col lg={!error ? 9 : 10} md={10} sm={12} xs={12}>
          <Row className="d-md-none">
            <Col>
              <SignRequestTitle
                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
                signRequest={item}
              />
            </Col>
          </Row>
          <Row className={"mt-2 mb-2 pl-4 pr-4"}>
            <Col lg={4} md={4} className="d-none d-md-block">
              <SignRequestTitle
                disabled={item.deleted}
                onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
                signRequest={item}
                icon
              />
            </Col>
            <Col lg={2} md={2} sm={6} xs={4}>
              <LabeledValue label="Předloženo" value={this.formatDate(item.created)} />
            </Col>
            <Col lg={2} md={2} sm={6} xs={8}>
              <LabeledValue label="Předkladatel" value={appUtils.getPracovnikLabel(item.pracovnikRequest)} />
            </Col>
            <Col lg={2} md={2} sm={6} xs={4}>
              {this.renderSignedOrRejected(item)}
            </Col>
            <Col lg={2} md={2} sm={6} xs={8}>
              <LabeledValue label="Podepisující" value={appUtils.getPracovnikLabel(item.pracovnikSign)} />
            </Col>
          </Row>
        </Col>
        {!error && (
          <Col lg={1} md={2} xs={6} sm={6} className=" justify-content-center d-none d-md-flex align-items-center">
            <RequestDocumentStatusIcon requestDocument={item} size="3x" />
          </Col>
        )}
        <Col md={2} lg={2} className={"action-button-wrapper d-none d-md-block"}>
          <ShowButton
            disabled={item.deleted}
            onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.BASE)}
          />
        </Col>
        {!error && (
          <Col
            xs={6}
            sm={6}
            className="d-md-none d-flex align-items-center justify-content-center"
            style={{
              borderTop: "1px solid #dfe2f1",
            }}
          >
            <RequestDocumentStatusIcon requestDocument={item} />
          </Col>
        )}
        <Col xs={6} sm={6} className="d-md-none mr-0">
          <Button
            block
            className={"btn-lg"}
            color={"primary"}
            onClick={() => this.handleZobrazit(item, null, PodepisovaniPdfViewer.VIEW_MODE.MOBILE)}
          >
            Zobrazit
          </Button>
        </Col>
      </Row>
    );
  };
  renderFilter = () => {
    return <VysledkyVyhledaniFilter />;
  };

  render() {
    const { itemList } = this.props;
    const listProps = {
      itemList,
      loadMore: actions.loadMore,
      invalidatePozadavky: actions.invalidate,
      renderItem: this.renderItem,
      renderActions: () => {},
      emptyList: (
        <MessageEmptyList>
          <div className="message">Nebyly nalezeny žádné dokumenty</div>
        </MessageEmptyList>
      ),
    };
    return (
      <CustomPageLayout
        header
        itemList={itemList}
        searchField={false}
        filter={this.renderFilter()}
        title="Výsledky vyhledání"
        mobilHeader="Vyhledávání"
        menu={<GroupMenu />}
      >
        <ItemList {...listProps} />
      </CustomPageLayout>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemList: utils.storeFromArea(state, actions.POZADAVKY_SEARCH_LIST),
  };
}

export default connect(mapStateToProps)(VysledkyVyhledaniPage);
